import React, { useContext, useEffect, useState } from 'react';
import http from '../../../lib/http'
import * as apis from '../../../lib/apis'
import { useNavigate } from 'react-router-dom';
import { Cell, Dialog, Toast } from '@nutui/nutui-react';
import TContext from '../context'
import { uploadFile } from '../../../lib/http';

const Index = (props: any) => {
    const navigate = useNavigate();

    const [list, setList] = useState<any>([])
    const [saving, setSaving] = useState(false);
    const tc = useContext(TContext)
    const [modelName, setModelName] = useState('');
    const [title, setTitle] = useState('');
    const [showSaveDialog, setShowSaveDialog] = useState(false);
    const [id, setId] = useState('');
    useEffect(() => {
        http.get(`${apis.USER_DESIGNER_list}`, {
            params: {
                page: '1',
                limit: 10
            }
        }).then(async (data: any) => {
            setList(data.list)
        })
    }, [])


    const sleep = (t: number) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null)
            }, t)
        })
    }

    const makeAndUploadImage = async (onProgress: any) => {
        //停止3D与2D的更新
        tc?.threeClient?.stopNeedsUpdate()
        const data: any = { effect_img: [], cutpart_img: [] }
        for (let i = 0; i < tc?.detailData?.model_materials?.cutparts?.length; i++) {
            let item = tc?.detailData?.model_materials?.cutparts[i]
            if (item.camera) {
                tc?.threeClient?.setCamera(item.camera.x, item.camera.y, item.camera.z)
            }
            await sleep(300)
            //获取blob
            const blob = await tc?.threeClient?.screePhoto()
            //上传效果图
            const ossData: any = await uploadFile(apis.UPLOAD_IMAGE, blob)
            if (!ossData.data.url) {
                Toast.fail(t("资源文件上传失败"))
                return
            }
            data.effect_img.push({
                code: item.code,
                img: ossData.data.url
            })
            onProgress(i / (tc?.detailData?.model_materials?.cutparts?.length - 1) * 100)
        }
        return data
    }
    const handleConfirmSave = async () => {
        if (!modelName.trim()) {
            Toast.text('请输入模型名称');
            return;
        }
        setSaving(true);

        try {
            const mdata = await makeAndUploadImage((p: any) => {
            })
            const resourceData: any = {}
            resourceData.canvas_width = tc?.fabricW as number
            resourceData.canvas_data = tc?.fabricClient?.allToJson()
            for (let i = 0; i < resourceData.canvas_data.length; i++) {
                let item = resourceData.canvas_data[i]
                let f = tc?.detailData?.model_materials?.cutparts?.find((j: any) => j.code === item.code)
                if (f) {
                    item.name = f.txt
                }
            }
            resourceData.model_url = tc?.detailData?.model_materials?.obj_url
            resourceData.map_info = tc?.curFabric
            resourceData.materials = mdata

            const ossData: any = await uploadFile(apis.UPLOAD_IMAGE, new Blob([JSON.stringify(resourceData)], { type: 'text/plain' }), "json")
            if (!ossData.data.url) {
                Toast.fail(t("提交失败,请重试"))
                Toast.hide()
                return
            }

            const data: any = {
                name: modelName,
                product_id: tc?.detailData?.product_id,
                resource_url: ossData.data.url,
                imgs: mdata.effect_img,
            }
            let api = apis.USER_DESIGNER_UPDATE + `/${tc?.detailData?.id}`
            http.post(`${api}`, data).then((res: any) => {
                reset()
                setSaving(false);
                navigate(`/cloth/pc/design/${id}?idType=formulaId`);
                tc?.titleChange(tc?.curCutpartCode)
                Toast.success(t("操作成功"));
            })

        } catch (error) {
            Toast.hide()
        }
    }
    const reset = () => {
        if (tc?.detailData?.name) {
            setModelName(tc.detailData.name);
        }
        setShowSaveDialog(false);

    };
    const handleDesignClick = (item: any) => {
        Dialog.confirm({
            title: '确认进入设计',
            content: `当前设计未保存，是否进行保存后跳转?`,
            onConfirm: () => {
                setShowSaveDialog(true);
                // 点击确认时跳转
                setId(item.id)
            },
            onCancel: () => {
                // 点击取消时关闭弹窗（自动处理）
                navigate(`/cloth/pc/design/${item.id}?idType=formulaId`);
            }
        });
    };

    // const handleDesignClick = (item: any) => {
    //     //    访问preview3D页面
    //     const directory = 'files';
    //     // "https://jxfdiy.oss-cn-hongkong.aliyuncs.com/files/e9859202511061815544689.json"
    //     const name = item.resource_url.split('/').pop();

    //     navigate(`/cloth/h5/preview/${directory}/${name}`);
    // }
    return (
        <div style={{
            padding: '0 16px',
            borderRadius: '12px',
            cursor: 'pointer',
        }}>
            {list.map((item: any, index: number) => (
                <div
                    key={item.id || index}
                    onClick={() => handleDesignClick(item)}
                    style={{
                        padding: '16px',
                        margin: '16px 0',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        transition: 'all 0.3s ease',
                        transform: 'scale(1)',
                        border: '1px solid #e8e8e8',
                        backgroundColor: '#ffffff',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px) scale(1.01)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                        e.currentTarget.style.borderColor = '#1890ff';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0) scale(1)';
                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.05)';
                        e.currentTarget.style.borderColor = '#e8e8e8';
                    }}
                >
                    {/* 悬停效果指示器 */}
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '4px',
                        height: '100%',
                        backgroundColor: '#1890ff',
                        transform: 'scaleX(0)',
                        transition: 'transform 0.3s ease',
                        transformOrigin: 'left'
                    }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scaleX(1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scaleX(0)';
                        }}
                    />

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '12px'
                    }}>
                        <div style={{ flex: 1, minWidth: 0, display: 'flex', justifyContent: 'space-between' }}>
                            {/* 主标题 */}
                            <div style={{
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#262626',
                                marginBottom: '4px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {item.name || '未命名设计'}
                            </div>

                            {/* 副标题和信息 */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                fontSize: '12px',
                                color: '#8c8c8c'
                            }}>
                                {item.designer_config && (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}>
                                        <span>{item.nickname}</span>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>

                    {/* 加载状态指示器（可选） */}
                    {item.loading && (
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            right: '16px',
                            transform: 'translateY(-50%)'
                        }}>
                            <div style={{
                                width: '16px',
                                height: '16px',
                                border: '2px solid #f0f0f0',
                                borderTop: '2px solid #1890ff',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                            }}></div>
                        </div>
                    )}

                </div>
            ))}
            {showSaveDialog && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10000,
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '420px',
                        maxWidth: '90vw',
                        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
                        animation: 'fadeIn 0.3s ease-out',
                    }}>
                        <h3 style={{
                            margin: '0 0 20px 0',
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#333',
                            textAlign: 'center',
                        }}>
                            {title}
                        </h3>

                        <div style={{ marginBottom: '20px', marginRight: '32px', }}>
                            <input
                                type="text"
                                placeholder="请输入模型名称"
                                value={modelName}
                                onChange={(e) => setModelName(e.target.value)}
                                style={{
                                    width: '100%',
                                    height: '44px',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '6px',
                                    padding: '0 16px',
                                    fontSize: '14px',
                                    outline: 'none',
                                    transition: 'border-color 0.3s',
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#409eff';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#e0e0e0';
                                }}

                                autoFocus
                            />

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: '8px',
                            }}>
                                <span style={{
                                    fontSize: '12px',
                                    color: '#999',
                                }}>
                                    {modelName.length}/50
                                </span>
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            gap: '12px',
                            justifyContent: 'flex-end',
                        }}>
                            <button
                                onClick={reset}
                                disabled={saving}
                                style={{
                                    padding: '10px 20px',
                                    border: '1px solid #dcdfe6',
                                    borderRadius: '6px',
                                    backgroundColor: 'white',
                                    color: '#606266',
                                    cursor: saving ? 'not-allowed' : 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    minWidth: '80px',
                                    opacity: saving ? 0.6 : 1,
                                }}
                            >
                                取消
                            </button>
                            <button
                                onClick={handleConfirmSave}
                                disabled={saving}
                                style={{
                                    padding: '10px 20px',
                                    border: 'none',
                                    borderRadius: '6px',
                                    backgroundColor: saving ? '#a0cfff' : '#409eff',
                                    color: 'white',
                                    cursor: saving ? 'not-allowed' : 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    minWidth: '80px',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                {saving ? '保存中...' : '保存'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <style>
                {`
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    `}
            </style>
        </div>
    )
}
export default Index
